export default function removeSortHash(filter) {
  let searchParams = new URLSearchParams(filter);
  searchParams.delete("page");
  searchParams.delete("order");
  searchParams.delete("orderby");
  searchParams.delete("meta_key");
  return searchParams.toString() ? `&${searchParams.toString()}` : "";
}
